<template>
  <div class="search-block-wrapper filter-input">
    <span class="fw6">{{ $t('common.search') }}</span>
    <Autocomplete
      :placeholder="$t('placeholder.sport_type_or_club')"
      icon="el-icon-right"
      :input-value="search"
      @emitSelection="saveSelection"
    />
    <button class="button accent-button" @click="searchTrainers">
      {{ $t('common.find') }}
    </button>
  </div>
</template>

<script>
import Autocomplete from '@/components/Common/AutocompleteHighlight'
import SetSportTypeClub from '@/dependencies/mixins/set-sport-type-club'
import WatchSportTypeClub from '@/dependencies/mixins/watch-sport-type-club'

export default {
  name: 'Search',
  components: {
    Autocomplete
  },
  mixins: [SetSportTypeClub, WatchSportTypeClub],
  data() {
    return {
      search: '',
      chosenItem: ''
    }
  },
  methods: {
    async saveSelection(item) {
      if (!item) {
        await Promise.all([this.setSportType(null), this.setSportClub(null)])
      } else {
        this.chosenItem = item
      }
    },
    async searchTrainers() {
      this.handleSelection()
      await this.setCurrentPage(1)
      const { page, ...query } = this.$route.query
      this.$router.push({
        name: this.$route.name,
        params: {
          pathMatch: this.getUrl,
          0: ''
        },
        query
      })
    }
  }
}
</script>

<style scoped lang="scss">
.search-block-wrapper {
  position: relative;
  padding: 25px 30px 20px 30px;
  background-color: white;
}
</style>
